export class PremioConsumidorModel {

    public seqConsumidor: number;
    public desTipoSorteioPremiacaoConsumidor: number;
    public seqSorteioPremiacaoConsumidor: number;
    public desSorteioPremiacaoConsumidor: number;
    public dtcRealizacaoSorteiroPremiacaoConsumidor?: Date;
    public seqPremioSorteioPremiacaoConsumidor?: number;
    public valPremioSorteioPremiacaoConsumidor?: number;
    public codSituacaoPremioSorteioPremiacaoconsumidor?: number;
    public desSituacaoPremioSorteioPremiacaoconsumidor?: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/model/premio-consumidor.model.ts